<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [disableCustomFont]="disableCustomFont"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  [role2ColorMapping]="role2ColorMapping"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="cs-icon cs-icon-initials mr-2"></i> <ng-container i18n>Initials</ng-container>
  </ng-container>
  <ng-container class="label">
    <i class="cs-icon cs-icon-initials"></i>
    <span *ngIf="role">{{ role }}</span> {{ label || 'Initials' }}
  </ng-container>
</app-field-renderer>
